import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import textContent from 'react-addons-text-content';
import { GroupTitle, GroupTitleText, GroupTitleAfter } from '../styled/ItemGroup';

var ItemGroup =
/*#__PURE__*/
function (_Component) {
  _inherits(ItemGroup, _Component);

  function ItemGroup() {
    _classCallCheck(this, ItemGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(ItemGroup).apply(this, arguments));
  }

  _createClass(ItemGroup, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          children = _this$props.children,
          elemAfter = _this$props.elemAfter,
          isCompact = _this$props.isCompact,
          title = _this$props.title,
          label = _this$props.label,
          innerRef = _this$props.innerRef,
          role = _this$props.role;

      var ariaLabel = function () {
        if (label) {
          return textContent(label);
        }

        if (title) {
          return textContent(title);
        }

        return '';
      }();

      return React.createElement("div", {
        "aria-label": ariaLabel,
        role: role,
        ref: innerRef
      }, title ? React.createElement(GroupTitle, {
        "aria-hidden": "true",
        isCompact: isCompact
      }, React.createElement(GroupTitleText, null, title), elemAfter ? React.createElement(GroupTitleAfter, {
        innerRef: function innerRef(r) {
          _this.headingAfterElement = r;
        }
      }, elemAfter) : null) : null, children);
    }
  }]);

  return ItemGroup;
}(Component);

_defineProperty(ItemGroup, "defaultProps", {
  role: 'group'
});

export { ItemGroup as default };